document.querySelectorAll('[data-sticky-cta]').forEach((bar) => {
  const key = `sticky-cta-dismissed-${window.location.pathname}`;

  if (sessionStorage.getItem(key)) {
    bar.remove();
    return;
  }

  bar.querySelector('[data-sticky-cta-dismiss]')?.addEventListener('click', () => {
    sessionStorage.setItem(key, '1');
    bar.remove();
  });

  if (bar.hasAttribute('data-hide-on-scroll-up')) {
    let lastY = window.scrollY;
    window.addEventListener(
      'scroll',
      () => {
        const goingUp = window.scrollY < lastY;
        bar.toggleAttribute('data-hidden', goingUp);
        lastY = window.scrollY;
      },
      { passive: true }
    );
  }
});
